import { createContext, useContext } from 'react';
import type { AdminError } from './adminApi';

/**
 * Lets any panel tell the dashboard that the server refused access (401 → sign
 * in again, 403 → not authorised) so the whole dashboard switches state, not
 * just the panel that noticed. Other errors stay local to the panel (FR-018).
 */
export type ReportAdminError = (error: AdminError) => void;

export const AdminAccessContext = createContext<ReportAdminError>(() => {});

export const useAdminAccess = () => useContext(AdminAccessContext);
